import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
declare var $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent {
    title = 'app';

    constructor(){
        $(document).on('mousedown', 'input[materialize="pickadate"]', function(e) {
            e.preventDefault();
            $(this).prop('readonly', true);
        });
    }
}
